// #### Dropzone

// This toggles "dropzone-active" class on any element with `phx-drop-target`
// when a drag is happening.

export const Dropzone = {
  init() {
    for (const eventName of ["dragenter", "dragover"])
      window.addEventListener(eventName, (evt) => this.toggle(evt.target, true))
    for (const eventName of ["dragleave", "drop"])
      window.addEventListener(eventName, (evt) =>
        this.toggle(evt.target, false),
      )
  },

  toggle(target, active) {
    const dropZone = target.closest("[phx-drop-target]")
    if (dropZone) dropZone.classList.toggle("dropzone-active", active)
  },
}
Dropzone.init()
